import {MAVISMART_FRONTEND_URL} from '@shared/env';

// !!! Make sure there is a corresponding pdf file in the folder `apps/mavismart_frontend/assets/terms`
// !!! For example, if the version is `v1`, there should be a file `apps/mavismart_frontend/assets/terms/v1.pdf`
export const LATEST_TERMS_VERSION = 'v2';

export const TERMS_VERSIONS = ['v1', LATEST_TERMS_VERSION] as const;

export type TermsVersion = (typeof TERMS_VERSIONS)[number];

export function parseTermsVersion(version: string): TermsVersion {
  if (!TERMS_VERSIONS.includes(version as TermsVersion)) {
    throw new Error(`Invalid TermsVersion: ${version}`);
  }
  return version as TermsVersion;
}

export function isLatestTermsVersion(version?: TermsVersion): boolean {
  return version === LATEST_TERMS_VERSION;
}

export function getTermsUrl(version: TermsVersion): string {
  return `${MAVISMART_FRONTEND_URL}/assets/terms/${version}.pdf`;
}

export function getPrivacyPolicyUrl(): string {
  return `${MAVISMART_FRONTEND_URL}/assets/privacy-policy.pdf`;
}
